/* Kesser theme — header: search drawer + mega-menu hover logic.
   Moved out of sections/header.liquid so it's cached as its own asset instead
   of being re-downloaded inline with every page's HTML. */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-search-bar]');
  if (drawer) {
    var input = drawer.querySelector('[data-search-input]');
    var results = drawer.querySelector('[data-search-results]');
    var debounceTimer;

    document.querySelectorAll('[data-search-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        drawer.classList.add('search-drawer--open');
        document.body.style.overflow = 'hidden';
        if (input) setTimeout(function () { input.focus(); }, 80);
      });
    });
    drawer.querySelectorAll('[data-search-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        drawer.classList.remove('search-drawer--open');
        document.body.style.overflow = '';
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { drawer.classList.remove('search-drawer--open'); document.body.style.overflow = ''; }
    });

    var renderResults = function (data, term) {
      if (!results) return;
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];
      var queries = (data.resources && data.resources.results && data.resources.results.queries) || [];
      if (!products.length && !queries.length) {
        results.innerHTML = '<div class="search-drawer__empty">Nenhum resultado para “' + term + '”</div>';
        results.hidden = false;
        return;
      }
      var html = '';
      if (queries.length) {
        html += '<div class="search-drawer__label">Sugestões</div>';
        queries.slice(0, 8).forEach(function (q) {
          html += '<a class="search-drawer__suggestion" href="' + q.url + '">' + q.title + '</a>';
        });
      }
      if (products.length) {
        html += '<div class="search-drawer__label search-drawer__label--products">Produtos</div>';
        products.slice(0, 10).forEach(function (p) {
          var img = p.featured_image ? p.featured_image.url : (p.image || '');
          html += '<a class="search-drawer__product" href="' + p.url + '">' +
            (img ? '<img src="' + img + '&width=100" alt="" loading="lazy">' : '<span class="search-drawer__product-ph"></span>') +
            '<span class="search-drawer__product-info"><span class="search-drawer__product-title">' + p.title + '</span>' +
            '<span class="search-drawer__product-price">' + p.price + '</span></span></a>';
        });
      }
      results.innerHTML = html;
      results.hidden = false;
    };

    if (input) {
      input.addEventListener('input', function () {
        var term = input.value.trim();
        clearTimeout(debounceTimer);
        if (term.length < 2) { if (results) { results.hidden = true; results.innerHTML = ''; } return; }
        debounceTimer = setTimeout(function () {
          fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product,query&resources[limit]=10&resources[options][fields]=title,product_type,variants.title')
            .then(function (r) { return r.json(); })
            .then(function (data) { renderResults(data, term); })
            .catch(function () {});
        }, 220);
      });
    }
  }

  document.querySelectorAll('.site-nav__item.has-dropdown').forEach(function (item) {
    var link = item.querySelector(':scope > a');
    var closeTimer;
    function openMega() {
      clearTimeout(closeTimer);
      item.classList.add('mega-open');
    }
    function scheduleClose() {
      closeTimer = setTimeout(function () { item.classList.remove('mega-open'); }, 120);
    }
    if (link) { link.addEventListener('mouseenter', openMega); }
    item.addEventListener('mouseleave', scheduleClose);
    item.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });

    var wraps = item.querySelectorAll('.shop-mega__cat-wrap');
    if (!wraps.length) return;
    wraps[0].classList.add('is-active');
    wraps.forEach(function (w) {
      w.addEventListener('mouseenter', function () {
        wraps.forEach(function (x) { x.classList.remove('is-active'); });
        w.classList.add('is-active');
      });
    });
  });
})();
